import b from 'b_';
import cx from 'classnames';
import React, { RefObject } from 'react';

import Link from '../../link/link';
import { THREE_DOTS_ITEM_TYPE } from '../typings';

import './three-dots__item.scss';

interface Props {
    children?: React.ReactNode | React.ReactNode[];
    mix?: string;
    onClick?: (e: React.MouseEvent<HTMLElement>) => void;
    type?: THREE_DOTS_ITEM_TYPE;
    withBorder?: boolean;
    disabled?: boolean;
}

const ThreeDotsItem = React.forwardRef((props: Props, ref: RefObject<Link>) => {
    const { children, mix, onClick, type = THREE_DOTS_ITEM_TYPE.PLAIN, withBorder, disabled } = props;

    return (
        <Link
            className={cx(mix, b('three-dots', 'item', { type, 'with-border': withBorder }))}
            disabled={disabled}
            onClick={onClick}
            pseudo
            ref={ref}
        >
            {children}
        </Link>
    );
});

ThreeDotsItem.defaultProps = {
    type: THREE_DOTS_ITEM_TYPE.ACTION,
    disabled: false,
};

ThreeDotsItem.displayName = 'ThreeDotsItem';

export default ThreeDotsItem;
